import { MessagesTitles, MessagesStatus } from './../../../models/messages';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { EmpresasService } from '../../../services/empresas/empresas.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { startWith, map } from 'rxjs/operators';
import { FormGroup, FormControl, Validators } from "@angular/forms";
import Swal from "sweetalert2";
import { LoginService } from 'app/services/login/login.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-list-adquirente',
  templateUrl: './list-adquirente.component.html',
  styleUrls: ['./list-adquirente.component.scss'],
  providers: [MessagesTitles, MessagesStatus]
})
export class ListAdquirenteComponent implements OnInit {
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_RefBancarias=environment.LABEL_REF_BANCARIAS;
  Id_Confirming=environment.ID_CONFIRMING;
  Id_Factoring=environment.ID_FACTORING;
  adjuntarLogo: boolean;
  rucEmpresa:any;
  form: FormGroup;
  id = '';
  ruc = new FormControl();
  Fruc = new FormControl();
  user: any;
  dataEmpresa: any;
  adjuntarPDF: boolean;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  pageSizeOptions = [10, 20, 30, 50, 100, 200];
  docNegociables: any = [];
  loading: boolean = false;
  displayedColumns: string[] =
    ['checked', 'Num_Doc_Identificacion', 'Razon_Social', 'RankingT10K', 'Scoring_Puntaje', 'Estado', 'Pagos'];
  dataSource = new MatTableDataSource(this.docNegociables);
  filteredAdquirentes: Observable<any[]>;
  filteredAdquirentes2: Observable<any[]>;

  adquirentesArr;
  adquirentesArr2;

  constructor(private empresasService: EmpresasService,
    private router: Router,
    private loginService: LoginService,
    private msgTitulos: MessagesTitles,
    private msgStatus: MessagesStatus,
    private activateRoute :ActivatedRoute) {

    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.displayedColumns = (this.user.id_roles == 45)? ['Num_Doc_Identificacion', 'Razon_Social', 'RankingT10K', 'Scoring_Puntaje', 'Estado', 'Pagos']:this.displayedColumns;
    
    this.form = new FormGroup({
      Estado: new FormControl('X', [Validators.required]),
      TipoEmpresa: new FormControl('A', [Validators.required]),
      Usuario: new FormControl(this.user.Usuario, [Validators.required]),
    });
  }

  ngOnInit() {
    this.empresasService.pagareDatos = "";
    this.activateRoute.params.subscribe( params => {
      if(params['id']){
        this.id =params['id'];
        this.filtradoAdquirentes2(this.id);
        this.ObtenerAdquirentesCombo();
        this.ObtenerAdquirentesComboRuc();
      }else{
        this.id='';
        this.cargarListado();
        this.ObtenerAdquirentesCombo();
        this.ObtenerAdquirentesComboRuc();
      }
    })
  }

  cargarListado() {
    this.loading = true;
    this.empresasService.obtenerListaAdquirentes(this.id)
      .subscribe(res => {
        this.docNegociables = res;
        this.loading = false;
        this.dataSource = new MatTableDataSource(this.docNegociables);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      }, (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA "+this.Label_Adquirente.toUpperCase()+". NO OBTENIDO. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      });
  }

  Pagare(element: any, rucEmpresa? : string) {
    this.loginService.clickGuard = true;
    sessionStorage.setItem('rucEmpresa',rucEmpresa);
    this.router.navigate(['/empresas/adquirente/pagare'])
    this.empresasService.pagareContrato = element;
    this.empresasService.pagareDatos = element;
    this.empresasService.pagareDatos.Tipo_Servicio = this.Id_Confirming;
  }

  obtenerRucRazSocial(termino: string = '') {

    if (termino != null && termino != '') {


      let termino1 = termino.toLowerCase();

      for (let p of this.adquirentesArr) {

        let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1) >= 0) {

          this.id = p.Num_Doc_Identificacion;
        }

      }

    }

  }


  ObtenerAdquirentesCombo() {
    this.adquirentesArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));
    this.filteredAdquirentes = this.ruc.valueChanges
      .pipe(
        startWith(""),
        map(state =>
          state ? this._filterProv(state) : this.adquirentesArr.slice()
        )
      );

  }

  private _filterProv(value: string): any[] {
    const filterValue = value.toString().toLowerCase();
    return this.adquirentesArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true
    );
  }



  ObtenerAdquirentesComboRuc() {
    this.adquirentesArr2 = JSON.parse(sessionStorage.getItem('lstAdqCbo'));

    this.filteredAdquirentes2 = this.Fruc.valueChanges
      .pipe(
        startWith(""),
        map(state =>
          state ? this._filterProvRuc(state) : this.adquirentesArr2.slice()
        )
      );


  }

  private _filterProvRuc(value: string): any[] {
    const filterValue = value.toString().toLowerCase();

    return this.adquirentesArr2.filter(
      state => state.Num_Doc_Identificacion.toLowerCase().indexOf(filterValue) === 0
    );
  }


  obtenerId(termino: string) {
    this.id = termino;
  }

  contratos(id?: string, razSocial?: string) {
    this.loginService.clickGuard = true;
    sessionStorage.setItem('razSocial', razSocial);
    this.empresasService.tipoServicio = this.Id_Confirming
    this.router.navigate(['/empresas/adquirente/contratos/', id])
  }

  subirAdjuntos(element: string) {
    this.dataEmpresa = element;
    this.adjuntarPDF = true;
  }

  subirLogo(element: string) {

    this.dataEmpresa = element;
    this.adjuntarLogo = true;


  }


  filtradoAdquirentes() {
    this.loading = true;

    if (this.ruc.value == null && this.Fruc.value == null || this.ruc.value == "" && this.Fruc.value == "") {
      this.id = "";
    }

    this.empresasService.obtenerListaAdquirentes(this.id)
      .subscribe(resp => {
        this.docNegociables = resp
        this.dataSource = new MatTableDataSource(this.docNegociables);

        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.pageSizeOptions = [15, 20, 30, 50, 100, 200];
        this.loading = false;
      }, (err1: HttpErrorResponse) => {
        this.loading = false;
        if (err1.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err1.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA "+this.Label_Adquirente.toUpperCase()+". NO OBTENIDO. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      });
  }

  filtradoAdquirentes2(id:any) {
    this.loading = true;

    if (this.ruc.value == null && this.Fruc.value == null || this.ruc.value == "" && this.Fruc.value == "") {
      this.id = "";
    }

    this.empresasService.obtenerListaAdquirentes(id)
      .subscribe(resp => {
        this.docNegociables = resp
        this.dataSource = new MatTableDataSource(this.docNegociables);

        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.pageSizeOptions = [15, 20, 30, 50, 100, 200];
        this.loading = false;
      }, (err1: HttpErrorResponse) => {
        this.loading = false;
        if (err1.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err1.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA "+this.Label_Adquirente.toUpperCase()+". NO OBTENIDO. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      });
  }

  contactos(id: string, razSocial?: string, rucEmpresa? : string) {
    this.loginService.clickGuard = true;
    sessionStorage.setItem('razSocial', razSocial);
    sessionStorage.setItem('rucEmpresa',rucEmpresa);
    this.router.navigate(['/empresas/adquirente/contactos/', id]);
  }

  referenciasBancarias(id: string, razSocial?: string, rucEmpresa? : string) {
    this.loginService.clickGuard = true;
    sessionStorage.setItem('razSocial', razSocial);
    sessionStorage.setItem('rucEmpresa',rucEmpresa);
    this.empresasService.tipoServicio = this.Id_Confirming
    this.router.navigate(['/empresas/adquirente/refBancarias/', id])

  }

  actualizarSStorageListAdq(idEmpresa: number, estado: string) {
    let arrAdq: any[] = JSON.parse(sessionStorage.getItem('lstAdqCbo'));

    arrAdq.forEach(adq => {
      if (Number(adq.idEmpresa) === idEmpresa) {
        adq.Estado = estado;
      }
    });

    sessionStorage.setItem('lstAdqCbo', JSON.stringify(arrAdq));
  }

  bloquear(idproveedor?: string, empresa?: string) {
    Swal.fire({
      title: '',
      text: '¿Estás seguro de bloquear al '+this.Label_Adquirente.toLowerCase()+' ' + empresa + '?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, bloquear '+this.Label_Adquirente.toLowerCase(),
      cancelButtonText: 'No, cancelar.',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: 'Espere',
          text: 'Guardando los cambios...',
          type: 'info',
          allowOutsideClick: false,
          heightAuto: false
        });
        Swal.showLoading();

        this.form.controls['Estado'].setValue('X');
        this.empresasService.actualizarEstadoEmpresa(idproveedor, this.form.getRawValue())
          .subscribe(
            res => {

              this.actualizarSStorageListAdq(Number(idproveedor), this.form.get('Estado').value);

              Swal.fire({
                title: '¡'+this.Label_Adquirente+' bloqueado!',
                text: res["message"],
                type: 'success',
                heightAuto: false
              }).then(resp => {
                if (resp.value) {
                  this.cargarListado();
                }
              });

            },
            (err: HttpErrorResponse) => {
              this.loading = false;
              if (err.error instanceof ErrorEvent) {
                console.error("Error Event");
              } else {
                this.msgStatus.getMessage(err.status);
              }
              Swal.fire({
                title: this.msgTitulos.Error,
                text: this.Label_Adquirente.toUpperCase()+" NO BLOQUEADO. " + this.msgStatus.message,
                type: "error",
                allowOutsideClick: false,
                heightAuto: false
              });
            }
          );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        this.loading = false
      }
    })
  }

  desbloquear(idproveedor?: string, empresa?: string) {
    Swal.fire({
      title: '',
      text: '¿Estás seguro de desbloquear al '+this.Label_Adquirente.toLowerCase()+ empresa + '?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, desbloquear '+this.Label_Adquirente.toLowerCase(),
      cancelButtonText: 'No, cancelar.',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: 'Espere',
          text: 'Guardando los cambios...',
          type: 'info',
          allowOutsideClick: false,
          heightAuto: false
        });
        Swal.showLoading();

        this.form.controls['Estado'].setValue('A');
        this.empresasService.actualizarEstadoEmpresa(idproveedor, this.form.getRawValue())
          .subscribe(
            res => {

              this.actualizarSStorageListAdq(Number(idproveedor), this.form.get('Estado').value);

              Swal.fire({
                title: '¡'+this.Label_Adquirente+' desbloqueado!',
                text: res["message"],
                type: 'success',
                heightAuto: false
              }).then(resp1 => {
                if (resp1.value) {
                  this.cargarListado();
                }
              });
            },
            (err: HttpErrorResponse) => {
              this.loading = false;
              if (err.error instanceof ErrorEvent) {
                console.error("Error Event");
              } else {
                this.msgStatus.getMessage(err.status);
              }
              Swal.fire({
                title: this.msgTitulos.Error,
                text: this.Label_Adquirente.toUpperCase()+" NO DESBLOQUEADO. " + this.msgStatus.message,
                type: "error",
                allowOutsideClick: false,
                heightAuto: false
              });
            }
          );
      } else if (
        result.dismiss === Swal.DismissReason.cancel
      ) {
        this.loading = false
      }
    })
  }

  darBaja(idproveedor?: string, empresa?: string) {
    Swal.fire({
      title: '',
      text: '¿Estás seguro de dar de baja en el sistema al '+this.Label_Adquirente.toLowerCase() + empresa + '?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, dar de baja',
      cancelButtonText: 'No, cancelar.',
      reverseButtons: true,
      heightAuto: false,
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: 'Espere',
          text: 'Guardando los cambios...',
          type: 'info',
          allowOutsideClick: false,
          heightAuto: false
        });
        Swal.showLoading();

        this.form.controls['Estado'].setValue('B');
        this.empresasService.actualizarEstadoEmpresa(idproveedor, this.form.getRawValue())
          .subscribe(res => {

            this.actualizarSStorageListAdq(Number(idproveedor), this.form.get('Estado').value);

            Swal.fire({
              title: '¡'+this.Label_Adquirente+'dado de baja en el sistema!',
              text: res["message"],
              type: 'success',
              heightAuto: false
            }).then(resp2 => {
              if (resp2.value) {
                this.cargarListado();
              }
            });

          })
      } else if (
        result.dismiss === Swal.DismissReason.cancel
      ) {
        this.loading = false
      }
    })
  }

  editar(id: string) {
    sessionStorage.setItem('rucEmpresa',id);
    this.loginService.clickGuard = true;
    this.router.navigate(['/empresas/adquirente/editar/', id])
  }

  CerrarPopUp() {
    this.adjuntarPDF = false;
  }
  CerrarPopUpLogo() {
    this.adjuntarLogo = false;
  }
}
